function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnGnbBack44 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uC0AC\\uAC01\\uD615 71",
  style: {
    fill: "none"
  },
  d: "M0 0h44v44H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uADF8\\uB8F9 1"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 1",
  d: "m1986.887 175.484-8 8 8 8",
  transform: "translate(-1966.887 -161.482)",
  style: {
    strokeLinejoin: "round",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 2",
  d: "M1981 175.4h20",
  transform: "translate(-1968 -153.397)",
  style: {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none"
  }
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnGnbBack44);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "6a13e217c64e00dcf9728d8a91827db2.svg";